import React from 'react';
import './IrrigationDetails.css';

const services = [
  {
    title: 'Sprinkler System Design & Installation',
    text:
      'We install sprinkler systems with zone layouts based on the size and shape of each area. Components are chosen to match local water pressure and soil conditions for even coverage and reliable performance. We also program controller settings based on seasonal needs.',
  },
  {
    title: 'Drip Irrigation',
    text:
      'Drip systems deliver water directly to the base of plants to help reduce evaporation and runoff. This method supports steady growth and works well for beds, shrubs, and trees with lower water needs.',
  },
  {
    title: 'Seasonal Startup & Winterization',
    text:
      'In the spring, we inspect and test the system, adjust heads, and update controller settings. In the fall, we shut down and clear the lines to help prevent freeze damage. We also check for worn or broken parts and make any needed replacements.',
  },
  {
    title: 'Leak Checks & Repairs',
    text:
      'We troubleshoot and repair issues like broken heads, valve problems, or damaged lines. Most parts are stocked in our vehicles for on-site repairs during the first visit. Regular checks help prevent small issues from turning into larger ones.',
  },
];

export default function IrrigationDetails() {
  return (
    <section className="irrigation-details">
      <div className="irrigation-details__container">
        <header className="irrigation-details__header">
          <h2 className="irrigation-details__title">Professional Irrigation System Services</h2>
             <div className="rl-title-underline"></div>
          <p className="irrigation-details__subtitle">
            We design, install, and maintain water-efficient irrigation systems to keep landscapes
            healthy while reducing waste.
          </p>
        </header>

        <div className="irrigation-details__grid">
          {services.map(({ title, text }) => (
            <article key={title} className="irrigation-details__card">
              <div className="irrigation-details__card-content">
                <h2 className="irrigation-details__card-title">{title}</h2>
                <p className="irrigation-details__card-text">{text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
